interface SwitchProps {
  on: boolean;
  onToggle: () => void;
  ariaLabel: string;
  disabled?: boolean;
}

/**
 * Accessible toggle switch. The reference uses a styled <span> — we use a real
 * <button role="switch" aria-checked> so keyboard + screen readers work properly.
 */
export function Switch({ on, onToggle, ariaLabel, disabled = false }: SwitchProps) {
  return (
    <button
      type="button"
      className={'switch' + (on ? ' on' : '')}
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onToggle}
    />
  );
}
